<template>
  <div class="datepicker" v-if="renderReady">
    <label v-if="getTitle" class="label">
      {{getTitle}}
      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{tooltipContent}}</w-tooltip>
    </label>

    <div
      class="input"
      :class="{'state-error': model.$error, 'state-disabled': disabled && !borderless}"
    >
      <input
        v-if="!datePickerVisible"
        type="text"
        ref="input"
        class="form-control"
        readonly="readonly"
        autocomplete="off"
        :class="{'borderless':borderless, 'is-invalid': this.model.$error}"
        :placeholder="datepicker.options.placeholder"
        :value="model.$value"
        :name="model.$form.testPath ? model.$path : undefined"
        @focus="toggleDatePicker()"
      />

      <datepicker
        v-bind:class="{ 'vdp-datepicker__left': leftSide, 'vdp-datepicker__top': topSide }"
        v-if="datePickerVisible"
        ref="datePicker"
        :input-class="{'form-control': true, 'borderless':borderless, 'is-invalid': this.model.$error}"
        :placeholder="datepicker.options.placeholder"
        :language="datepicker.language"
        :format="datepicker.options.format"
        :value="model.$model"
        :clear-button="datepicker.options.clearButton"
        :disabled="disabled"
        :disabledDates="getDisabledDates"
        :full-month-name="true"
        :open-date="openDate"
        @input="dateChanged"
        @focus="onFocus($event)"
        @blur="pickerBlur($event)"
        @closed="pickerBlur($event)"
      ></datepicker>
    </div>

    <w-error
      :model="model"
      @focus="datePickerVisible ? $refs.input.focus() : $refs.datePicker.focus()"
    ></w-error>
  </div>
</template>

<script>
import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';
import WTooltip from './tooltip.vue';
import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js';
import pl from 'vuejs-datepicker/dist/locale/translations/pl';
import {schemaMethods} from '@witkac/jschema';

// import {pl} from 'vuejs-datepicker/dist/locale';

export default {
  name: 'w-datepicker',
  components: {WError, Datepicker, WTooltip},
  props: {
    placeholder: String,
    dateOptions: Object,
    disabledDates: Object,
    position: {
      // bottom-left; bottom-right; top-left; top-right
      type: String,
      default: 'bottom-right'
    }
  },
  mixins: [modelMixin],
  data() {
    const dateOpts = {
      placeholder: this.placeholder || '',
      format: 'dd.MM.yyyy'
    };
    return {
      datePickerVisible: false,
      datepicker: {
        language: pl,
        value: '',
        options: {...dateOpts, ...this.dateOptions}
      }
    };
  },

  methods: {
    toggleDatePicker() {
      if (this.datePickerVisible) {
        this.hideDatePicker();
      } else {
        if (!this.model.$schema.readOnly) {
          this.showDatePicker();
        }
      }
    },
    showDatePicker() {
      this.datePickerVisible = true;
      const self = this;
      // pokae się dopiero za chwilę
      this.$nextTick(() => {
        self.$refs.datePicker.$el.children[0].children[0].focus();
        self.$refs.datePicker.showCalendar();
        self.model.$hasFocus = true;
      });
    },
    hideDatePicker() {
      this.datePickerVisible = false;
      const self = this;

      this.$nextTick(() => {
        self.model.$hasFocus = false;
        // self.$refs.datePicker.showCalendar();
      });
    },
    pickerBlur($event) {
      console.log('pickerBlur');
      this.hideDatePicker();
      // onBlur($event);
    },

    dateChanged(newValue) {
      const tnewvalue = newValue.getTime();

      if (this.localValue === undefined || tnewvalue !== this.localValue) {
        // this.resize(newValue);
        // console.log('dtpicker', newValue);
        this.localValue = tnewvalue;
        const pad = num => {
          if (num >= 10) {
            return num;
          } else {
            return '0' + num;
          }
          // const norm = Math.floor(Math.abs(num));
          // return (norm < 10 ? '0' : '') + norm;
        };
        // const stringValue = newValue.getFullYear() + '-' + pad(newValue.getMonth() + 1) + '-' + pad(newValue.getDate());
        const stringValue = schemaMethods.fdatetime(newValue, 'dd.MM.yyyy');
        // console.log('dateChanged', newValue, tnewvalue, this.localValue, stringValue);
        // const stringValue = pad(newValue.getDate()) + '.' + pad(newValue.getMonth() + 1) + '.' + newValue.getFullYear();
        // this.localValue = stringValue;
        this.$emit('input', stringValue);
        this.fieldChanged();

        if (!this.$options.vmodel) {
          if (this.$options.lazy) {
            // if (this.lazy) {
            // return;
          }
          // sets in model
          const nvalue = schemaMethods.fdate(newValue); // yyyy-MM-dd
          // const nvalue = newValue.getFullYear() + '-' + pad(newValue.getMonth() + 1) + '-' + pad(newValue.getDate());
          // console.log('dt newvalue', nvalue);
          this.model.$model = nvalue;

          this.model.$hasFocus = false;
          // this.model.$value = stringValue;
          // this.hideDatePicker();
          // wymus odczyt
          // console.log(this.model.$value);
        }
      }
    }
    /*

    clickOutside() {
      this.hideDatePicker();

      document.removeEventListener('click', this.clickOutside, true);
    }
    */
  },
  computed: {
    leftSide() {
      return this.position.includes('left');
    },
    topSide() {
      return this.position.includes('top');
    },
    getDisabledDates() {
      let disabledDates = this.disabledDates;
      const $schema = this.model.$schema;
      // const minimumDate = this.model.$schema.minimum;
      // const maximumDate = this.model.$schema.maximum;
      if (disabledDates === undefined) {
        disabledDates = {};
      }
      if ($schema.exclusiveMinimum) {
        disabledDates.to = schemaMethods.dateParse($schema.exclusiveMinimum + ' 23:59:59');
      }
      if ($schema.minimum) {
        // disabledDates.to = new Date(minimumDate);
        disabledDates.to = schemaMethods.dateParse($schema.minimum + ' 00:00:00');
      }
      if ($schema.exclusiveMaximum) {
        disabledDates.from = schemaMethods.dateParse($schema.exclusiveMaximum + ' 00:00:00');
        // disabledDates.from = new Date(maximumDate);
      }
      if ($schema.maximum) {
        disabledDates.from = schemaMethods.dateParse($schema.maximum + ' 23:59:59');
        // disabledDates.from = new Date(maximumDate);
      }
      return disabledDates;
    },
    openDate: {
      get() {
        return this.getDisabledDates.to || new Date();
      }
    }
  },
  watch: {
    dateOptions(next, prev) {
      this.datepicker.options = {...this.datepicker.options, ...next};
    },
    placeholder(next, prev) {
      this.$set(this.datepicker.options, 'placeholder', next);
    }
  }
};
</script>

<style>
.vdp-datepicker__left > div:not(:first-child) {
  right: 0%;
}
.vdp-datepicker__top > div:not(:first-child) {
  bottom: 100%;
}
.vdp-datepicker__calendar .cell.selected {
  color: #fff;
  background-color: #a90329;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  background-color: #428bca;
  color: white;
}
.vdp-datepicker__calendar header {
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
}
.vdp-datepicker__calendar .cell {
  border: 1px solid transparent !important;
}
.vdp-datepicker__calendar .cell.selected::before,
.vdp-datepicker__calendar .cell.selected::after {
  content: none;
}
</style>
